import axios from 'axios'
import _ from 'lodash'

const state = {
  trainingItems: []
}

const mutations = {
  SET_TRAINING_LIST: (state, { list }) => {
    state.trainingItems = list
  }
}

const actions = {
  LOAD_TRAINING_LIST: function ({ commit }) {
    axios.get('/api/collections/get/jesshamer').then((response) => {
      commit('SET_TRAINING_LIST', { list: response.data })
    });
  }
}

const getters = {
  training: state => state.trainingItems.entries,
  getTrainingById: state => id => _.find(state.trainingItems.entries, { 'title_slug': id })
}

const trainingModule = {
  state,
  mutations,
  actions,
  getters
}

export default trainingModule;
